export default {
  warningList: [
    '投資者不應只根據艾德證券期貨網頁及艾德一站通應用程式內容而作出任何投資決定。投資者作出投資決定前應先參閱有關基金銷售文件及細閱基金公司所刊發有關基金資料單張上列明的基金特色以及有關風險。您可在艾德一站通應用程式內或相關基金公司網頁查閱基金銷售文件。',
    '基金乃投資產品而部份涉及金融衍生工具。投資決定是由閣下自行作出的，但閣下不應投資在該基金，除非中介人於銷售該產品時已向閣下解釋經考慮閣下的財務情況、 投資經驗及目標後，該產品是適合閣下的。',
    '基金產品並不相等於定期存款。',
    '投資涉及風險。過去的業績並不代表將來的表現。投資價值及基金的收入/股息可升可跌，不能保證能賺取利潤。',
    '在最壞情況下，基金價值或會大幅地少於您的投資金額（在極端的情況下，您投資的回報可能會變成沒有價值）。',
    '基金的投資可能涉及廣泛的市場，貨幣，波幅，流動性，監管及政治風險。',
    '如基金涉及投資於新興市場，單一市場或限量地區市場或行業或小型企業，基金可能會涉及較高風險,並通常對價格變動較敏感。',
    '如基金投資於金融衍生工具，或會涉及額外的風險以及可能承受較高的波幅。',
    '如投資以外幣計值，有關港元換算均屬指示性，僅供參考。投資總值會以港幣顯示，而持有個別基金的價值則以相關貨幣顯示。'
  ],
  applyFund: '基金賬戶申請',
  fundTarget: `開通基金賬戶前，您需要先完成風險問卷測評，以確認您的投資風險偏好。 <br>
  本風險取向問卷旨在協助本公司了解閣下或閣下所代表的公司的投資目標、風險取向和風險承擔，以助本公司確定合適閣下或閣下所代表的公司風險取向的投資選擇。 `,
  warnText: '重要提示及免責聲明',
  importText: `閣下可以於填寫本風險取向問卷的時候向本公司提出問題及索取獨立意見。當完成本風險取向問卷並獲評定風險取向及風險承擔後，相關的資料會被記錄於本公司並用於提供投資建議和評估該投資者是否適合相關的投資產品或服務。及以此問卷之回覆更新閣下個人資料(如適用)。本公司將按照本風險取向問卷所提供資料作出評估，如其中的資料包含重大遺漏、錯誤或虛假陳述，本公司謹此免除就所有相關索賠、要求及訴訟承擔責任。假如我們向閣下招攬銷售或建議任何金融產品，該金融產品必須是我們經考慮閣下的財政狀況、投資經驗及投資目標後而認為合理地適合閣下的。本協議的其他條文或任何其他我們可能要求閣下簽署的文件及我們可能要求閣下作出的聲明概不會減損本條款的效力。`,
  toRisk: '前往測評',
  toOpenaccount: '跳過測評，直接開戶',
  openStock: '請先開通證券賬戶後再開通基金賬戶',
  disclosure: '風險披露',
  agreeText: '本人已閱讀及同意本',
  protocol: '基金銷售服務協議',
  and: '及',
  riskProtocol: '基金交易重要風險提示',
  sureBtnText: '確認開通基金賬戶',
  warntextAgree: '您需要閱讀並勾選相關協議才能提交',
  chooseAppropriate: '請選擇適當的選項',
  riskAssess: '風險測評',
  name: '姓名：',
  idText: '身份證 / 護照號碼：',
  ageError: '年齡組別不符',
  level1: '1（低風險）',
  level2: '2（低至中等風險）',
  level3: '3（中等風險）',
  level4: '4（中等至高風險）',
  level5: '5（高風險）',
  level1Text: '保守型',
  level2Text: '穩健型',
  level3Text: '平衡型',
  level4Text: '增長型',
  level5Text: '進取型',
  xing: '型',
  normal: '普通投資者',
  desText1:
    '您可選擇投資於低風險的投資產品，以債券及現金為主以達到穩定回報的目的。如此一來，您要明白所收取的回報也較低。 ',
  desText2:
    '您可以接受低至中風險及價格波動，並有一些的投資回報。',
  desText3:
    '您可選擇多元化及較均衡的股票、債券及現金投資組合。您願意承擔中等級別的風險，以便在中長期內賺取一些潛在回報。',
  desText4:
    '您可以接受高風險及價格波動，並且有資本增值的投資。',
  desText5:
    '您可選擇投資於任何風險級別的衍生產品、投資基金和/或其他金融產品。您願意承擔高級別的風險，以便在中長期內得到最大的潛在回報。您知道您可能損失大部份或全部資本，您甚至可能須對資本以外的虧損作出補償。 ',
  riskTitle: '風險等級',
  resultText: '評估結果',
  category: '具體類別',
  desc: '描述',
  investorType: '投資者類型',
  target: '投資目標',
  investmentPeriod: '投資年期',
  declareAssets: '申報淨資產',
  derivativesKnowledge: '衍生品知識',
  reTest: '結果有誤，重新測評',
  openFund: '確認結果無誤',
  agreeRiskText:
    '本人同意並確認本風險取向問卷的總結能準確地形容本人或本人所代表的公司的風險取向',
  all: '共',
  specialText: '道題，已回答',
  daoti: '道題',
  Disclaimer: '免責聲明',
  disclaimerText: `1.本問卷的結果是從閣下向艾德證券期貨有限公司(「艾德證券期貨」)提供的資料，並根據若干普遍接納的假設及合理估算而得出。本問卷採用的方法及取值謹供說明用途。艾德證券期貨對本問卷所載數據及/或所得結果的準確性或完整性並不負責或承擔任何法律責任。 </br>2.本問卷及所得結果謹供閣下參考，並非購買或出售任何金融產品及服務的要約或招攬、亦不應被視為投資意見或推薦。 </br>3.請注意，倘若閣下未能全面披露所有或任何有關閣下的個人狀況(如財務狀況)、不正確、不完整或過時的數據可能影響本集團評估閣下對投資風險的態度及承受能力。如閣下的狀況出現變動而可能影響本問卷中任何問題的答案，我們極力建議閣下再次填寫本問卷。 `,
  disclaimerText1: '1.本人/吾等謹此聲明，按本人/吾等所知，本人/吾等在本文件提供的資料真確無誤。本人/吾等同意，如此資料有任何變動，本人/吾等將會在合理可行情況下儘快以書面通知艾德證券期貨有限公司(“艾德”)。本人/吾等同意以上的風險評估結果。本人/吾等確認，就本人提供不完整或不正確資料所導致的任何行動或遺漏，艾德概不負上任何責任。',
  disclaimerText2: '2.本問卷及測試結果僅供參考，並不構成投資建議，亦不得視為建議游說買賣任何投資產品及服務。艾德對本問卷內容及結果的準確性及完整性概不作出任何保證。極力建議客戶最少每年一次或在個人狀況及生重大轉變時，檢討客戶對投資風險的見解，以確保投資決定仍然配合對投資風險取向的態度。',
  disclaimerText3: '3. 請注意，倘若閣下未能全面披露所有或任何有關閣下的個人狀況(如財務狀況)、不正確、不完整或過時的資料可能影響本集團評估閣下對投資風險的態度及承受能力。如閣下的狀況出現變動而可能影響本問卷中任何問題的答案，我們極力建議閣下再次填寫本問卷。',
  openReview: '開戶審核中',
  fivemins: '大約1-2個工作天後可開通',
  return: '返回',
  notBackInfo: '退出後，已填寫信息將不保存',
  dialogTitle: '確定要退出當前頁？',
  secondInfo: '本人聲明，因未理解題目，或個人狀況發生改變需要重新評估',
  retestTitle: '重新測評',
  totest: '去測評',
  fundsSource: '請注明資金來源(多選)',
  placeholderFundsSource: '請輸入資金來源',
  infoSame: '本人確認本人其他資料並無改變，與開戶時所提交的資料相同',
  notAccept: '就業情況和資金來源不匹配',
  hadVaAcount: '閣下已開通了虛擬資產賬戶，不支持將現有的風險等級調整為其他風險等級，如有疑問，歡迎致電+852 2655 0338 / 400 120 0068（中國內地免費熱線）或電郵至cs@eddidsec.com與客戶服務部聯絡。',
  signTitle: '請在下方白色區域內簽好你的姓名，盡量佔滿區域',
  readSign: '已閱讀，去簽名',
  statement: [
    {
      zh: '為保障閣下購買投資產品的利益，艾德證券期貨有限公司（「艾德」）已就閣下是否被歸類為容易受損客戶（「容易受損客戶」）進行評估。',
      en: 'In order to protect your interests in purchasing investment products, Eddid Securities and Futures Limited (“EDDID”) has conducted an assessment on whether you are classified as a vulnerable client (“VC”) or not.'
    },
    {
      zh: '根據我們的評估，閣下被歸類為容易受損客戶。然而，考慮到閣下的投資經驗及背景，我們將根據閣下從客戶風險評估問卷（「客戶風險評估問卷」）中評估獲得的投資風險取向，評估閣下是否適合投資於特定投資產品（如適用）。',
      en: 'Based on our assessment, you are classified as a VC. However, in view of your investment experience and background, we will assess your suitability on investing in particular investment products (where applicable) based on your Investment Risk Profile obtained from the Risk Profiling Questionnaire (“RPQ”).'
    },
    {
      zh: '此聲明書適用於所有本人/吾等屬實益擁有人的賬戶。',
      en: 'This declaration form applies to all accounts of which I am / We are the beneficial owner.'
    },
    {
      zh: '通過在此聲明書上簽署，本人/吾等確認：',
      en: 'By signing on this form, I /We confirm that:'
    },
    {
      zh: '本人/吾等同意艾德將本人/吾等歸類為容易受損客戶；',
      en: '1.I /We agree to be treated as a VC by EDDID;'
    },
    {
      zh: '於作出投資決定時，本人在精神上有能力做出獨立的投資決策，儘管考慮到本人的年齡及/或其他被視作容易受損客戶的狀況（包括任何明顯的殘疾）；',
      en: '2.I am mentally capacitated to make independent investment decisions, despite my age and/or other vulnerable conditions (including any observable disabilities) in making investment decision;'
    },
    {
      zh: '本人在此賬戶中所進行的投資，將按照客戶風險評估問卷評估結果中獲得的投資風險取向進行合適性評估；',
      en: '3.the suitability assessment for my investments transacted in this Account will be based on the Investment Risk Profile obtained from the assessment result of the RPQ;'
    },
    {
      zh: '本人將能夠就可能涉及較高風險的投資產品（包括損失超過投資金額的可能性）進行交易，儘管考慮到本人的年齡及/或其他被視作容易受損客戶的狀況；及',
      en: '4.notwithstanding my age and/or other vulnerable conditions, I will be able to deal in investment products which may involve higher risks (including the possibility of losses exceeding the amount invested); and'
    },
    {
      zh: '本人在投資產品銷售和下單過程中，無須攜伴。',
      en: '5.I am not required to bring along a companion during the sales process for investment products and placing orders.'
    }
  ],
  hadGreen: '我已閱讀並同意',
  hadFiveTimes: '根據我們的記錄，閣下於過去30日曾完成客戶風險評估問卷{number}次或以上。如果閣下對風險評估問卷的問題有任何查詢，歡迎隨時致電 +852 2655 0338 / 400 120 0068（中國內地免費熱線） 或電郵至 cs@eddidsec.com 與客戶服務部聯絡。',
  continueAssessment: '繼續評估',
  useUpChange: '今日測試次數已用完，請明天再試。',
  haveChanges: '你今日還能測試({number})次，請謹慎作答。',
  hadAgreeCustomerDeclaration: '本人已查閱並確認',
  customerDeclaration: '《容易受損客戶聲明書》',
  readDeclaration: '本人/吾等已閱讀本人所申請的產品資金概要、注釋備忘錄及其他銷售資料。本人/吾等聲明及同意本人/吾等完全明白並接受有關產品之特性包括但不限於潛在之風險、回報及損失。本人/吾等確定根據本人/吾等於「客戶風險評估問卷」所披露之現時需要及投資風險概況，有關產品之特色及其風險級別均適合本人/吾等。',
  pleaseSign: '請簽署姓名信息。',
  weWillCallyou: '我們會盡快聯絡閣下，與閣下進行確認及解釋一般投資風險。閣下同意假如我們未能聯絡閣下，閣下的風險類別將會重設為「保守型」。',
  readAndSigned: '已閱讀並簽署',
  vulnerable: '容易受損客戶聲明書',
  title1: '重要提示',
  description1: [
    '本客戶風險評估問卷旨在協助本公司瞭解閣下或閣下所代表的公司的投資目標、風險取向和風險承擔，以助本公司確定適合閣下所代表的公司風險取向的投資選擇。',
    '閣下確認開立帳戶過程中提供的資料，包括但不限於客戶風險評估問卷，均是真實、準確和有效的，能夠準確、真實地反映閣下的狀況、意願、投資目標、風險偏好和風險承受能力。',
    '閣下知悉本公司將依賴最新提交的客戶風險評估問卷的結果作為評估投資產品是否適合閣下的依據。閣下確認及同意，如閣下的風險等級有所變動，閣下有可能被限制交易某些產品 (如虛擬資產)。',
    '閣下知悉本公司會根據閣下在先前的客戶風險評估問卷內所提供的資料，自動就某些問題輸入答案。',
    '閣下確認及同意，如閣下知悉早前提供予本公司的訊息已過時或不再準確，未能真實、準確地反映閣下狀況時, 會盡快聯絡客服更新帳戶資料。',
    '閣下確認及同意，如本公司發現閣下的資料出現前後不一致，可以較遲者為準，並有權隨時聯絡閣下跟進。'
  ],
  title2: '重要提示及免責聲明',
  description2: '閣下可以於填寫本客戶風險評估問卷的時候向本公司提出問題及索取獨立意見。當完成本客戶風險評估問卷並獲評定風險取向及風險承擔後，相關的資料會被記錄於本公司並用於提供投資建議和評估該投資者是否適合相關的投資產品或服務。本公司將按照本客戶風險評估問卷所提供資料作出評估，如其中的資料包含重大遺漏、錯誤或虛假陳述，本公司謹此免除就所有相關索賠、要求及訴訟承擔責任。',
  description3: '假如我們向閣下招攬銷售或建議任何金融產品，該金融產品必須是我們經考慮閣下的財政狀況、投資經驗及投資目標後而認為合理地適合閣下的。本協議的其他條文或任何其他我們可能要求閣下簽署的文件及我們可能要求閣下作出的聲明概不會減損本條款的效力。',
  btnReEvaluate: '重新測評'
}
